module.exports = __webpack_public_path__ + "static/media/portfolio-summary.7d7f955b.png";